import styled from 'styled-components'

const DaneIdentyfikacyjneStyle = styled.div`
  .checkboxLabel {
    height: 24px;
  }

  .identyfikacjaPodmiotu {
    width: 100%;
    display: grid;
    grid-row-gap: 24px;
  }

  .identyfikacjaPodmiotu .pkd {
    width: 100%;
    padding-bottom: 20px;
  }

  .identyfikacjaPodmiotu .krs {
    display: grid;
    grid-auto-flow: column;
    grid-gap: 16px;
    justify-content: start;

    .text {
      width: 184px;
    }
  
  }

  .identyfikacjaPodmiotu .buttonGUS {
      margin-top: 12px;
      //  margin-left: 16px;
    }
  

  .siedziba {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto;
    grid-row-gap: 24px;
  }
  .siedziba .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 304px 304px 344px;
    grid-column-gap: 16px;
  }
  .siedziba .miejscowosc {
    width: 304px;
    grid-row: 2/3;
  }

  .adres {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
    grid-row-gap: 24px;
  }
  .adres .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: 304px 304px 344px;
    grid-column-gap: 16px;
  }
  .adres .secondRow {
    grid-row: 2/3;
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }
  .adres .thirdRow {
    grid-row: 3/4;
    display: grid;
    grid-template-columns: 304px 104px 304px 84px;
    grid-column-gap: 16px;
  }

  .adresZagraniczny {
    width: 100%;
    display: grid;
    grid-template-rows: auto auto auto;
  }
  .adresZagraniczny .firstRow {
    grid-row: 1/2;
    display: grid;
    grid-template-columns: auto auto;
    grid-column-gap: 8px;
  }
  .adresZagraniczny .secondRow {
    grid-row: 2/3;
    margin-top: 12px;
    display: grid;
    grid-template-columns: 424px 104px 84px;
    grid-column-gap: 16px;
  }
  .adresZagraniczny .thirdRow {
    grid-row: 3/4;
    margin-top: 24px;
    display: grid;
    grid-template-columns: 104px 304px 84px;
    grid-column-gap: 16px;
  }
  
  // .buttonGUS {
  //   margin-top: 12px;
  //   margin-left: 16px;
  // }

`
export default DaneIdentyfikacyjneStyle
